<template>
    <div class="container my-3">
        <!--style="position: fixed;left: 50%;
    transform: translateX(-50%);" -->
        <b-form-group class="container" >
            <b-input-group>
                <b-form-textarea
                        id="filterInput"
                        ref="filterInput"
                        :class="[osmanlicaMiYaziyor ? 'searchTextOsm' : '']"
                        v-model="aranacakKelime"
                        style="height: calc(1.5em + 0.75rem + 2px);"
                        v-on:keyup.delete="SilmeyeBasildi"
                        placeholder="Latince veya Osmanlıca Arama Yapabilirsiniz"
                ></b-form-textarea>
            </b-input-group>
        </b-form-group>

        <b-row  class="d-flex justify-content-center"
                style="margin-left: 0px; margin-right: 0px; direction: rtl; padding-top: 0px;">
            <div v-for="(h, index) in harfler"
                 style="direction: rtl;"
                 :key="index">
                <b-button variant="info"
                          style="direction: rtl;"
                          class="btn-osmanlica-harf"
                          @click="osmKeyBasildi(h.kod, $event)">
                    {{h.harf}}
                </b-button>
            </div>

            <b-button
                    @click="karakterYaz('.')"
                    variant="info" style="width: 50px; margin: 0.1em;" >
                .
            </b-button>
            <b-button
                    @click="karakterYaz('*')"
                    variant="info" style="width: 50px; margin: 0.1em;" >
                *
            </b-button>

            <b-button style="width: 50px; margin: 0.1em;" @click="geriSilmeTusunaBasildi">
                <b-icon icon="backspace-fill"></b-icon>
            </b-button>
        </b-row>

        <div ref="scrollIntoTheView"></div>
        <div class="mt-3">
            <p>- Bilinmeyen harf yerine . (nokta) koyarak arayabilirsiniz</p>
            <p>- Bilinmeyen yan yana birkaç harf yerine * koyarak arayabilirsiniz</p>
            <p><a href="https://nisanyanmap.com" target="_blank">- Yer adları araması yapmak için tıklayınız. </a></p>
            <p><a href="https://turkadlar.com/" target="_blank">- Şahıs isimleri araması yapmak için tıklayınız. </a></p>
        </div>


        <b-table class="mt-5"
                 :busy="isBusy"
                 striped
                 hover
                 :current-page="currentPage"
                 :per-page="0"
                 empty-text="Kayıt Bulunamadı"
                 show-empty
                 stacked="sm"
                 :fields="fields"
                 :items="sonuclar">
            <template v-slot:table-busy>
                <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Yükleniyor...</strong>
                </div>
            </template>
            <template v-slot:cell(osmanlica)="data" >
                <div class="osmanlicaCol">
                    {{data.value || ''}}
                </div>
            </template>
        </b-table>
        <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="fill"
                size="sm"
                class="my-0"
        ></b-pagination>
    </div>
</template>

<script>
    import _ from 'lodash'
    import {Sorgula} from "@/api/latinceOsmanlica"
    export default {
        name: "latinceosmanlica",
        data() {
            return {
                totalRows: 1,
                currentPage: 1,
                perPage: 0,
                aranacakKelime: '',
                isBusy: false,
                osmanlicaMiYaziyor: false,
                sonuclar: [],
                fields: [
                    { key: 'latince', Label: 'Latince', sortable: true },
                    { key: 'osmanlica', Label: 'Osmanlica', sortable: false },
                    { key: 'kaynak', Label: 'Kaynak', sortable: false }
                ],
                harfler: [
                    { harf: 'ا' , kod: '1575' },
                    { harf: 'ب' , kod: '1576' },
                    { harf: 'پ' , kod: '1662' },
                    { harf: 'ت' , kod: '1578' },
                    { harf: 'ث' , kod: '1579' },
                    { harf: 'ج' , kod: '1580' },
                    { harf: 'چ' , kod: '1670' },
                    { harf: 'ح' , kod: '1581' },
                    { harf: 'خ' , kod: '1582' },
                    { harf: 'د' , kod: '1583' },
                    { harf: 'ذ' , kod: '1584' },
                    { harf: 'ر' , kod: '1585' },
                    { harf: 'ز' , kod: '1586' },
                    { harf: 'ژ' , kod: '1688' },
                    { harf: 'س' , kod: '1587' },
                    { harf: 'ش', kod: '1588' },
                    { harf: 'ص' , kod: '1589' },
                    { harf: 'ض' , kod: '1590' },
                    { harf: 'ط' , kod: '1591' },
                    { harf: 'ظ' , kod: '1592' },
                    { harf: 'ع' , kod: '1593' },
                    { harf: 'غ' , kod: '1594' },
                    { harf: 'ف' , kod: '1601' },
                    { harf: 'ق' , kod: '1602' },
                    { harf: 'ك' , kod: '1603' },
                    { harf: 'ل' , kod: '1604' },
                    { harf: 'م' , kod: '1605' },
                    { harf: 'ن' , kod: '1606' },
                    { harf: 'و' , kod: '1608' },
                    { harf: 'ه' , kod: '1607' },
                    { harf: 'ﻻ' , kod: '65275' },
                    { harf: 'ی' , kod: '1740' },

                    /*{ harf: 'ؤ' , kod: '1572' },
                    { harf: 'ٯ' , kod: '1647' },
                    { harf: 'ة' , kod: '1577' },
                    { harf: 'ئ' , kod: '1574' },
                    { harf: 'ى' , kod: '1609' },*/
                    //{ harf: 'ۀ' , kod: '1728' },
                   /* { harf: 'گ' , kod: '1711' },
                    { harf: 'ڭ' , kod: '1709' },
                    { harf: 'إ' , kod: '1573' },
                    { harf: 'أ' , kod: '1571' },
                    { harf: 'آ' , kod: '1570' },*/
                ]
            }
        },
        watch: {
            aranacakKelime: {
                handler: async function (searchText) {
                    if (searchText === "")
                        return
                    this.currentPage = 0

                    const osmAramasiMi = this.isArabic(searchText.charAt(0))
                    this.aramaYap(this.currentPage, searchText, osmAramasiMi, this, false)
                }
            },
            currentPage: {
                handler: function (value) {
                    if (this.aranacakKelime === "")
                        return;

                    const osmAramasiMi = this.isArabic(this.aranacakKelime.charAt(0))
                    this.aramaYap(value, this.aranacakKelime, osmAramasiMi, this, true)
                }
            }
        },
        methods: {
            isArabic(s) {
                const arabic = /[\u0600-\ufefc]/;
                if (s === '‘' || s === '“' || s === '”' || s === '‘')
                    return false

                return arabic.test(s)
            },
            aramaYap : _.debounce(async (pageNo, kelime, osmAramasiMi, vm, pagination) => {

                let aramaPattern = "";
                if (kelime.indexOf(".") > -1)
                    aramaPattern = kelime;
                else if (kelime.indexOf("*") > -1)
                    aramaPattern = kelime.replace("*", ".*");
                else {
                    if (osmAramasiMi)
                        aramaPattern = kelime + ".*";
                    else
                        aramaPattern = "^" + kelime + ".*";
                }
//عريف
//عریف
                console.log(aramaPattern)

                vm.isBusy = true
                const { data, totalRows } = await Sorgula(pageNo, aramaPattern, osmAramasiMi)
                vm.totalRows = totalRows
                vm.sonuclar = data
                vm.isBusy = false
                if(pagination) {
                    vm.$nextTick(() => {
                        vm.$refs.scrollIntoTheView.scrollIntoView()
                    })
                }

            }, 1000),
            osmKeyBasildi(unicode) {
                this.osmanlicaMiYaziyor = true

                this.karakterInputuGuncelle(String.fromCharCode(unicode))

            },
            karakterYaz(kar) {
                this.karakterInputuGuncelle(kar)
            },
            karakterInputuGuncelle(char) {
                const ref = this.$refs.filterInput
                let strPos = ref.selectionStart;
                let strEnd = ref.selectionEnd;
                let strTop = ref.scrollTop;
                ref.focus()


                let front = this.aranacakKelime.substring(0, strPos);
                let back = this.aranacakKelime.substring(strPos, ref.value.length);

                this.aranacakKelime = front + char + back
            },

            geriSilmeTusunaBasildi() {
                this.aranacakKelime = this.aranacakKelime.substr(0, this.aranacakKelime.length - 1);

                if (this.aranacakKelime.length === 0)
                    this.osmanlicaMiYaziyor = false
            },
            SilmeyeBasildi() {
                if(this.aranacakKelime === "")
                    this.osmanlicaMiYaziyor = false
            }
        }
    }
</script>

<style scoped lang="scss">

    .btn-osmanlica-harf {
        font-size: 25px;
        font-family: "Hanzala";
        width: 50px;
        margin: 0.1em;
    }
    .searchTextOsm {
        font-size: 2em;
        font-family: "Hanzala";
        direction: rtl;
    }

    .osmanlicaCol {
        font-size: 30px;
        font-family: "Hanzala";
    }

    @media (max-width: 500px) {
        .form-group {
            margin-bottom: 0.5em;
        }
    }

</style>
